import React from 'react';
import Button from '@material-ui/core/Button';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import ListItem from "@material-ui/core/ListItem";
import _, { omit, pick, round, slice } from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, FormLabel, FormHelperText, Paper } from '@material-ui/core';
import { actions } from "../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "../_Services/publicFunction";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Qs from "qs";
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import painDiagram from "../pictures/pain.jpg"
import CardMedia from '@material-ui/core/CardMedia';

import Body from './BackBody';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useSound from 'use-sound';
import clickdown from '../sounds/clickdown.wav';
import clickup from '../sounds/clickdown.wav';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from "notistack";

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 8,
        // borderRadius: 5,
    },
    colorPrimary: {
        //backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
    root: {
        color: theme.palette.type === "dark" ? "#1a90ff" : "#3f51b5"
    },
    media: {
        height: 350,
        width: 550,
        // objectFit: 'cover'
    },
    submitButton: {
        width: "100%", background: '#2E3B55', fontWeight: "bold",
        "&:hover": {
            background: '#fffff',
            // color:'#2E3B55'
        }
    },

}));

const Questionaire69th = props => {
    // const [progress, setProgress] = React.useState(0);
    const [numerator, setNumerator] = React.useState(0)
    const [denominator, setDenominator] = React.useState(18)
    const { handleNext, setActiveStep } = props;
    const dispatch = useDispatch();
    const { UserInfo } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
    }));
    const scoreObj = {
        0: "不痛",
        1: "痛可忽略",
        2: "可能影響工作",
        3: "影響工作",
        4: "影響自主活動功能",
        5: "完全無法自主活動",
    }
    const classes = useStyles();
    const [playActive] = useSound(
        clickdown,
        { volume: 0.25 }
    );
    const [playOn] = useSound(
        clickup,
        { volume: 0.25 }
    );
    const [uploadFormat, setUpload] = React.useState({
        0: { BarCodeStr: "", QuestionNo: 69, Category: "填寫前說明", titleNo: "", Title: "下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。酸痛不適程度與關節活動能力：（以肩關節為例）", SelectTitle: "", Answer: "", Other: "" },
        1: { BarCodeStr: "", QuestionNo: 69, Category: "一、基本資料", titleNo: 1, Title: "您平常使用電腦、滑鼠慣用手為？", SelectTitle: "○左手  ○右手", Answer: "", Other: "" },
        2: { BarCodeStr: "", QuestionNo: 69, Category: "一、基本資料", titleNo: 2, Title: "您在過去的1年內，身體是否有長達2星期以上的疲勞、酸痛、發麻、刺痛等不舒服，或關節活動受到限制？", SelectTitle: "○否（若否，結束此調查表）  ○是（若是，請繼續填寫下列表格。）", Answer: "", Other: "" },
        3: { BarCodeStr: "", QuestionNo: 69, Category: "一、基本資料", titleNo: 3, Title: "下表的身體部位酸痛、不適或影響關節活動之情形持續多久時間？", SelectTitle: "○1個月  ○3個月  ○6個月  ○1年  ○3年  ○3年以上", Answer: "", Other: "" },
        4: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "", Title: "痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)：0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』", SelectTitle: "", Answer: "", Other: "" },
        5: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "01", Title: "頸部", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        6: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "02", Title: "上背部", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        7: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "03", Title: "下背部", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        8: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "04", Title: "左肩部", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        9: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "05", Title: "右肩部", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        10: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "06", Title: "左手肘/左前臂", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        11: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "07", Title: "右手肘/右前臂", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        12: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "08", Title: "左手/左手腕", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        13: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "09", Title: "右手/右手腕", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        14: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "10", Title: "左臀/左大腿", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        15: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "11", Title: "右臀/右大腿", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        16: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "12", Title: "左膝", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        17: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "13", Title: "右膝", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        18: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "14", Title: "左腳踝/左腳", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        19: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "15", Title: "右腳踝/右腳", SelectTitle: "○0  ○1  ○2  ○3  ○4  ○5", Answer: "", Other: "" },
        20: { BarCodeStr: "", QuestionNo: 69, Category: "二、痠痛症狀調查", titleNo: "16", Title: "其他症狀、病史說明", SelectTitle: "＿", Answer: "", Other: "" },
    });
    const [done, setDone] = React.useState(false);
    const [preDone, setpreDone] = React.useState(false);
    const intl = useIntl();
    React.useEffect(() => {
        //寫入BarCodeStr
        let obj = Object.values(uploadFormat).reduce((o, { }, index) => {
            o[index] = { BarCodeStr: UserInfo.BarCodeStr }
            return o
        }, {})
        let newitem = _.merge(uploadFormat, obj);
        // console.log(newitem)
        setUpload(prevState => newitem);

    }, [])
    const { enqueueSnackbar } = useSnackbar();

    // React.useEffect(() => {
    //     console.log(numerator, denominator)
    //     console.log((numerator / denominator) * 100)
    // }, [uploadFormat])
    const validator = () => {
        const form = formRef.current; //參數1
        if (form.checkValidity()) {
            // console.log("全部通過")
            //若驗證通過，刪除錯誤提示
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];

                if (Object.keys(uploadFormat).includes(element.name)) {
                    setUpload(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error", "helperText"])
                    }));
                }

            }
            return true;
        } else {
            // const form = formRef.current;
            // console.log("還沒通過")
            alert(intl.formatMessage({ id: "尚有問題未完成" }));
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    console.log(element.validationMessage, element.name);
                    console.log(element.value)
                    // console.log(element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
                        }));
                    }


                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    console.log("Pass", element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error", "helperText"])
                        }));
                    }

                }
            }
            return false;
        }
    }

    const handleSubmit = e => {
        e.preventDefault();
        // console.log(uploadFormat)
        //setError(!error);
        if (validator()) {

            dispatch(actions.TAB_EDIT({ editing: true, key: 69 }))

            PF.instance({
                method: "post",
                url: PF.url + "/Questionaire/Insert",
                data: Qs.stringify({ list: Object.values(uploadFormat) }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    console.log(response.data)
                    const { TotalRecord, ErrorMessage } = response.data
                    if (TotalRecord <= 0) {
                        // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #169 企業健檢")
                        enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        setDone(true);
                        enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
                    }
                })
        }
    }
    const BodyObj = {
        5: { cx: 52.5, cy: 10 },//OK"頸部"
        6: { cx: 52.5, cy: 20 },//OK"上背部"
        7: { cx: 52.5, cy: 37.5 },//OK"下背部"
        8: { cx: 45, cy: 15, ax: 25, ay: 15 },//OK"左肩部"
        9: { cx: 60, cy: 15, ax: 7.5, ay: 15 },//OK"右肩部"
        10: { cx: 40, cy: 30, ax: 27.5, ay: 30 },//OK"左手肘/左前臂"
        11: { cx: 65, cy: 30, ax: 5, ay: 30 },//OK"右手肘/右前臂"
        12: { cx: 40, cy: 42.5, ax: 28, ay: 42.5 },//OK"左手/左手腕"
        13: { cx: 65, cy: 42.5, ax: 4, ay: 42.5 },//OK"右手/右手腕"
        14: { cx: 47.5, cy: 52, ax: 22.5, ay: 52 },//OK"左臀/左大腿"
        15: { cx: 57.5, cy: 52, ax: 10, ay: 52 },//OK"右臀/右大腿"
        16: { cx: 47.5, cy: 67.5, ax: 22.5, ay: 67.5 },//OK"左膝"
        17: { cx: 57.5, cy: 67.5, ax: 10, ay: 67.5 },//OK"右膝"
        18: { cx: 47.5, cy: 90, ax: 20, ay: 90 },//OK"左腳踝/左腳"
        19: { cx: 57.5, cy: 90, ax: 12, ay: 90 },//OK"右腳踝/右腳"
    }
    const handleRadioChange = e => {
        // e.prevetDefault();
        if (!done) {
            const { name, value } = e.target;
            // console.log(name, value)
            // setValue(value);
            if (name === "2" && value.includes("否")) { //選2結束
                // console.log("predone");
                setpreDone(true);
                setDenominator(2);
                //清除Answer
                Object.keys(uploadFormat).forEach(k => {
                    if (k > 2) {
                        uploadFormat[k].Answer = ""
                    }
                })
                setUpload(prevState => ({
                    ...prevState,
                    [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
                }))

                if (uploadFormat[1].Answer !== "") {
                    setNumerator(prev => 2)
                } else {
                    setNumerator(prev => 1)
                }

            } else if (name === "2") {      //選2繼續，且是
                setpreDone(false);
                setDenominator(18);
                // console.log("繼續");
                //console.log(uploadFormat)
                setUpload(prevState => ({
                    ...prevState,
                    [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
                }))
                if (uploadFormat[name].Answer == "") {
                    setNumerator(prev => prev + 1)
                }

            } else if (name === "1") {
                setUpload(prevState => ({
                    ...prevState,
                    [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
                }))
                if (uploadFormat[name].Answer == "") {
                    setNumerator(prev => prev + 1)
                }
            }
            else {
                if (!preDone) {
                    setUpload(prevState => ({
                        ...prevState,
                        [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
                    }))
                    if (uploadFormat[name].Answer == "") {
                        setNumerator(prev => prev + 1)
                    }
                }

            }
            //console.log(uploadFormat)

            if (name >= 5) {
                setCircle(prevState => ({
                    r: 5,
                    cx: BodyObj[name].cx,
                    cy: BodyObj[name].cy
                }));
                setColor(colorList[value]);
            }
            if (name >= 5) {
                setFrontCircle(prevState => ({
                    r: name >= 8 ? 5 : 0,
                    cx: BodyObj[name].ax || 5,
                    cy: BodyObj[name].ay || 5
                }));
            }

        }
    }
    const handleTxtChange = e => {
        if (!done) {
            if (!preDone) {
                const { name, value } = e.target;
                setUpload(prevState => ({
                    ...prevState,
                    [name]: { ...prevState[name], BarCodeStr: UserInfo.BarCodeStr, Answer: value }
                }))
                setCircle(prevState => ({
                    r: 0,
                    cx: 5,
                    cy: 5,
                }))
                setFrontCircle(prevState => ({
                    r: 0,
                    cx: 5,
                    cy: 5,
                }))
            }

        }
    }
    const colorList = {
        0: "#1976d2", 1: "#4caf50", 2: "#ffea00", 3: "#ff9100", 4: "#FF0000", 5: "#ab003c"
    }
    const [color, setColor] = React.useState("#FF0000")
    const formRef = React.createRef();
    const [circle, setCircle] = React.useState({
        cx: 5, cy: 5, r: 0
    })
    const [frontCircle, setFrontCircle] = React.useState({
        cx: 5, cy: 5, r: 0
    })
    return (
        <Paper>
            <h1 style={{ textAlign: "center" }}><FormattedMessage id={"肌肉骨骼症狀調查表"} /></h1>
            <form onSubmit={handleSubmit} ref={formRef} noValidate>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"填寫前說明"} /></Typography></legend>
                    <Typography><FormattedMessage id={"下列任何部位請以酸痛不適與影響關節活動評斷。任選分數高者。"} /></Typography>
                    <Typography><FormattedMessage id={"酸痛不適程度與關節活動能力：（以肩關節為例） 請在第二部分作答"} /></Typography>
                    <CardMedia
                        className={classes.media}
                        image={painDiagram}
                        component='img'
                    />
                </fieldset>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"基本資料"} /></Typography></legend>
                    {Object.values(uploadFormat).slice(1, 4).map((item, index) => {
                        return (
                            <FormControl component="fieldset" error={item.error} required={index == 2 ? !preDone : true} className={classes.formControl} key={index}>
                                <FormLabel component="legend" className={classes.root}>{item.titleNo + "."}<FormattedMessage id={item.Title} /></FormLabel>
                                <RadioGroup name={item.titleNo} value={item.Answer} onChange={handleRadioChange} style={{ display: "block" }}>
                                    {item.SelectTitle.replaceAll("○", "").split("  ").map(pro => {
                                        return (
                                            <FormControlLabel value={pro} control={<Radio color="primary" required={index == 2 ? !preDone : true} />} label={<FormattedMessage id={pro} />} onMouseDown={() => { playActive() }} />)
                                    })}
                                </RadioGroup>
                                <FormHelperText>{item.error ? <FormattedMessage id={item.helperText} /> : null}</FormHelperText>
                            </FormControl>)
                    })}
                </fieldset>
                <div style={{
                    position: "fixed",
                    top: "180px",
                    right: "0"
                }} >
                    <Body circle={circle} color={color} frontCircle={frontCircle} />
                </div>
                <fieldset style={{ marginBottom: "50px" }} >
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"痠痛症狀調查"} /></Typography></legend>
                    <Typography><FormattedMessage id={"痠痛症狀調查(請對應位置，在量化後的分數欄位中點選)："} /></Typography>
                    <Typography><FormattedMessage id={"0表示『不痛』;1表示『痛可忽略』;2表示『可能影響工作』;3表示『影響工作』;4表示『影響自主活動功能』;5表示『完全無法自主活動』"} /></Typography>
                    {Object.values(uploadFormat).slice(5, 20).map((item, index) => {
                        return (
                            <FormControl component="fieldset" error={item.error} required={!preDone} className={classes.formControl} key={index}>
                                <FormLabel component="legend" className={classes.root}>{item.titleNo + "."}<FormattedMessage id={item.Title} /></FormLabel>
                                <RadioGroup name={index + 5} value={item.Answer} onChange={handleRadioChange} style={{ display: "block" }}>
                                    {item.SelectTitle.replaceAll("○", "").split("  ").map((pro, id) => {
                                        return (
                                            <Tooltip title={intl.formatMessage({ id: scoreObj[id] })} placement="top">
                                                <FormControlLabel value={pro} control={<Radio color="primary" required={!preDone} />} label={<><span>{<FormattedMessage id={pro} />}</span>{"."}<span>{intl.formatMessage({ id: scoreObj[id] })}</span></>} onMouseDown={() => { playActive() }} />
                                            </Tooltip>)
                                    })}
                                </RadioGroup>
                                <FormHelperText>{item.error ? <FormattedMessage id={item.helperText} /> : null}</FormHelperText>
                            </FormControl>)
                    })}
                    <div style={{ padding: "0px 20px 20px 10px" }}>
                        <ListItem button >
                            {/* 最後一題 */}
                            <TextField label={uploadFormat[20].titleNo + "." + intl.formatMessage({ id: uploadFormat[20].Title })} autoComplete="off" onChange={handleTxtChange} name={"20"} value={uploadFormat[20].Answer} fullWidth
                            />
                        </ListItem>
                    </div>
                </fieldset>
                <div style={{ width: '100%', bottom: !done ? "36px" : "0px", position: "fixed", }}>
                    <BorderLinearProgress variant="determinate" value={(numerator / denominator) * 100} />
                </div><br /><br />
                {!done ? (<div style={{ top: 'auto', bottom: 0, position: "fixed", width: "100%" }}>
                    <Button variant="contained" color="primary" type="submit" onClick={handleSubmit} className={classes.submitButton}><FormattedMessage id={"app.Submit"} /></Button>
                </div>) : null}
            </form>
        </Paper>
    )



}

export default Questionaire69th
